import * as Keychain from 'react-native-keychain';

export const getUserName = async () => {
  try {
    const credentials = await Keychain.getGenericPassword();
    if (credentials && credentials.username === 'username') {
      return credentials.password;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const setUserNameToken = async (userName: string) => {
  //const biometricSupport = await Keychain.getSupportedBiometryType();
  if (userName) {
    try {
      await Keychain.setGenericPassword('username', userName, {
        accessible: Keychain.ACCESSIBLE.WHEN_UNLOCKED,
      });
      return true;
    } catch (error) {
      return false;
    }
  }
};
